<template>
  <section>
    <div
      :style="{ backgroundImage: 'url(/assets/bg-header-desktop.svg)' }"
      class="image"
    ></div>
  </section>
</template>

<style scoped>
.image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 8rem;
  width: 100%;
  background-color: #5ba4a4;
}
</style>
